export const mastercard = [
  '0 0 32 32',
  `
<path fill="#252525" d="M2.667 5.333h26.667c1.473 0 2.667 1.194 2.667 2.667v16c0 1.473-1.194 2.667-2.667 2.667h-26.667c-1.473 0-2.667-1.194-2.667-2.667v-16c0-1.473 1.194-2.667 2.667-2.667z"></path>
<path fill="#eb001b" d="M18.667 16c0 3.682-2.985 6.667-6.667 6.667s-6.667-2.985-6.667-6.667c0-3.682 2.985-6.667 6.667-6.667s6.667 2.985 6.667 6.667z"></path>
<path fill="#f79e1b" d="M26.667 16c0 3.682-2.985 6.667-6.667 6.667s-6.667-2.985-6.667-6.667c0-3.682 2.985-6.667 6.667-6.667s6.667 2.985 6.667 6.667z"></path>
<path fill="#ff5f00" d="M16 10.666c1.619 1.216 2.667 3.153 2.667 5.334s-1.047 4.118-2.667 5.334c-1.619-1.216-2.667-3.153-2.667-5.334s1.047-4.118 2.667-5.334z"></path>

`,
]
